"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var usePlatformConfig_1 = require("./usePlatformConfig");
var useCustomerStorage_1 = require("../hooks/useCustomerStorage");
exports.usePersistedCurrencyPreference = function () {
    var _a = react_1.useState(false), isSecondaryCurrencyDisplay = _a[0], setIsSecondaryCurrencyDisplay = _a[1];
    var priceDisplay = usePlatformConfig_1.default().platformConfig.priceDisplay;
    var primary = priceDisplay.primary, secondary = priceDisplay.secondary;
    var customerStorage = useCustomerStorage_1.default().customerStorage;
    var storageInfo = customerStorage.getCustomerData();
    var storageCurrency = react_1.useMemo(function () { var _a, _b; return _b = (_a = storageInfo) === null || _a === void 0 ? void 0 : _a.selectedCurrency, (_b !== null && _b !== void 0 ? _b : ''); }, [storageInfo]);
    react_1.useEffect(function () {
        var _a;
        if (storageCurrency === ((_a = secondary) === null || _a === void 0 ? void 0 : _a.currency)) {
            setIsSecondaryCurrencyDisplay(true);
        }
    }, []);
    react_1.useEffect(function () {
        var _a, _b;
        storageInfo.selectedCurrency = isSecondaryCurrencyDisplay ? (_a = secondary) === null || _a === void 0 ? void 0 : _a.currency : (_b = primary) === null || _b === void 0 ? void 0 : _b.currency;
        customerStorage.setCustomerData(storageInfo);
    }, [isSecondaryCurrencyDisplay]);
    return { isSecondaryCurrencyDisplay: isSecondaryCurrencyDisplay, setIsSecondaryCurrencyDisplay: setIsSecondaryCurrencyDisplay };
};
